import { createFileRoute } from "@tanstack/react-router";
import { Suspense } from "react";
import { Taxes } from "@/components/Taxes";

function TaxesContent() {
  return <Taxes />;
}

function RouteComponent() {
  return (
    <Suspense fallback={<div>Loading...</div>}>
      <TaxesContent />
    </Suspense>
  );
}

export const Route = createFileRoute("/_authenticated/taxes/")({
  component: RouteComponent,
  staticData: { page: "tax" },
});
